import axios from "axios";

const API = process.env.REACT_APP_API_URL;

export const getHauliers = async (params) => {
	const { data } = await axios.get(`${API}/admin/hauliers`, {
		params,
	});
	return data;
};

export const getHaulier = async (params) => {
	const { data } = await axios.get(`${API}/admin/hauliers/detail`, {
		params,
	});
	return data;
};

export const saveHaulier = async (params) => {
	const { data } = await axios.post(`${API}/admin/hauliers/save`, params);
	return data;
};

export const deleteHaulier = async (params) => {
	const { data } = await axios.post(`${API}/admin/hauliers/delete`, params);
	return data;
};
